// extracted by mini-css-extract-plugin
export default {"wrapper":"CookiesFooter_wrapper__eUUBn","descr":"CookiesFooter_descr__KTuqH","link":"CookiesFooter_link__DjEd1"};